'use strict';

import './dealerChatButton.scss';
import template from './dealerChatButton.template.html';
import controller from './dealerChatButton.controller.js';

const component = {
    bindings: {
        stockTypeCode: '@',
        customerId: '@',
        modelYear: '@',
        makeName: '@',
        modelName: '@',
        listingId: '@',
        vin: '@',
        price: '@',
        stockNumber: '@',
        pageFromId: '@',
        buttonTitle: '@',
        isCpoVehicle: '@',
        isDealerInspire: '<'
    },
    controller,
    template
};

export default component;
